<template>
  <div>
    <div class="m-6 pt-4" v-if="!cancel && data && data.status == 0 && data.check3Day == false">
      <div class="text-center">
        <h3 class="bold" v-if="!refusal">Duyệt đề xuất bổ sung giờ làm việc ngoài văn phòng</h3>
        <h3 class="bold" v-else>Từ chối đề xuất bổ sung giờ làm việc ngoài văn phòng</h3>

      </div>
      <div class="text-left d-flex justify-content-center col-md-12 pb-4">
        <div class="col-md-5 rounded bg-white pb-6">
          <div class="col-md-12 d-flex mt-5">
            <div class="col-md-7 text-left">Địa chỉ email: </div>
            <div class="col-md-5 text-left">{{ data.user ? data.user.email : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Mã nhân sự: </div>
            <div class="col-md-5 text-left">{{ data.user_id + 100000 }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Họ và tên: </div>
            <div class="col-md-5 text-left">{{ data.user ? data.user.name : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Vị trí: </div>
            <div class="col-md-5 text-left">{{ data.user && data.user.profile && data.user.profile.account_type ? data.user.profile.account_type.name : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Phòng ban: </div>
            <div class="col-md-5 text-left">{{ data.department_user.department ? data.department_user.department.name : '' }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Ngày cần bổ sung: </div>
            <div class="col-md-5 text-left">{{ data.start_date }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Thời gian bắt đầu: </div>
            <div class="col-md-5 text-left">{{ data.time_checkin }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Thời gian kết thúc: </div>
            <div class="col-md-5 text-left">{{ data.time_checkout }}</div>
          </div>
          <div class="col-md-12 d-flex mt-3">
            <div class="col-md-7 text-left">Lý do xin bổ sung: </div>
            <div class="col-md-5 text-left" v-html="renderTextWithLinks(data.reason)"></div>
          </div>
          <div class="col-md-12 d-flex mt-3" v-if="data.overtime_results">
            <div class="col-md-7 text-left">Kết quả bổ sung giờ làm việc ngoài văn phòng: </div>
            <div class="col-md-5 text-left" v-html="renderTextWithLinks(data.overtime_results)"></div>
          </div>
          <div class="col-md-12 d-flex mt-3" v-if="refusal">
            <div class="col-md-7 text-left bold">Nhập lý do từ chối <span class="text-danger">*</span></div>
          </div>
          <div class="col-md-12 d-flex mt-3" v-if="refusal">
            <textarea v-model="reason" class="w-100 rounded" name="" id="" cols="100" rows="10"></textarea>
          </div>
          <p v-if="message" class="col-md-12 text-danger">{{ this.message }}</p>

          <div class="col-md-12 d-flex justify-content-center mt-3">
            <el-button @click="confirmCancel">Hủy bỏ</el-button>
            <el-button @click="confirm">Xác nhận</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6" v-else-if="data.id">
      <ConfirmPropose
        :data="data"
        :checkPropose="checkPropose"
        :cancel="cancel"
        :publicPath="publicPath"
        :refusal="refusal"
      ></ConfirmPropose>
    </div>
  </div>
</template>

<script>
import ConfirmPropose from "./ConfirmPropose";
export default {
  name: "AddWorkingHours",
  components: {
    ConfirmPropose
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    refusal: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_URL,
      checkPropose: false,
      cancel: false,
      reason: '',
      message: ''
    }
  },
  methods: {
        renderTextWithLinks(text) {
            if (!text) return '—';
            let str = String(text);
            let urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
            let escaped = str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
            return escaped.replace(urlRegex, (url) => {
                let href = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
                return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: #472f92; text-decoration: underline; font-weight: 600; word-break: break-all;" class="mr-1">${url} <i class="fa fa-external-link"></i></a>`;
            });
        },

    confirm() {
      if (this.refusal && this.reason == '') {
        this.message = 'Lý do từ chối không được để trống';
        return;
      }

      this.checkPropose = true;
      this.$emit('confirm', this.reason);
      // eslint-disable-next-line vue/no-mutating-props
      this.data.status = 1;
      this.message = '';


    },
    confirmCancel() {
      this.cancel = true;
    }
  }
}
</script>

<style scoped>

</style>